import { Button } from "primereact/button";

import { buttonLogin, formLogin } from "../../_constants";

export const LoginBtn = () => {
  return (
    <div className="flex-container justify-end">
      <Button
        label={buttonLogin}
        className="login-button"
        type="submit"
        form={formLogin}
      ></Button>
    </div>
  );
};
